import React from 'react';

const DOM_Methods = () => {
  return (
    <div >
      <h1>DOM_Methods</h1>
      <p>Placeholder component for: "DOM Methods"</p>
    </div>
  );
};

export default DOM_Methods;
